const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20play%20button%20overlay%20on%20a%20dark%20newsroom%20scene%2C%20warm%20red%20and%20amber%20lighting%2C%20broadcast%20studio%20atmosphere%2C%20professional%20video%20production%20aesthetic%2C%20cinematic%20color%20grading&width=800&height=500&seq=media-01-911&orientation=landscape',
    title: '2026年7月吃瓜黑料视频合集精选',
    duration: '15:32',
    tag: '月度精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20studio%20interview%20setup%20with%20warm%20rim%20lighting%2C%20professional%20broadcast%20environment%2C%20dark%20background%20with%20subtle%20red%20accents%2C%20investigative%20journalism%20aesthetic%2C%20cinematic%20composition&width=800&height=500&seq=media-02-911&orientation=landscape',
    title: '独家深度：某选秀节目资本运作全揭秘',
    duration: '22:08',
    tag: '深度报道',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20smartphone%20screens%20displaying%20social%20media%20feeds%2C%20dark%20background%2C%20warm%20accent%20lighting%2C%20modern%20digital%20lifestyle%20concept%2C%20professional%20product%20photography%20style&width=800&height=500&seq=media-03-911&orientation=landscape',
    title: '网红翻车现场实录：直播事故大合集',
    duration: '10:45',
    tag: '翻车合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20press%20conference%20scene%20with%20multiple%20microphones%20and%20warm%20stage%20lighting%2C%20professional%20media%20event%20atmosphere%2C%20dark%20background%2C%20editorial%20photography%20style&width=800&height=500&seq=media-04-911&orientation=landscape',
    title: '年度盘点：2026上半年十大爆料事件',
    duration: '28:15',
    tag: '年度特辑',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              视频<span className="text-primary-500">吃瓜</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              精选911吃瓜黑料视频内容，直观感受每一个爆料现场
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-100 rounded-xl overflow-hidden cursor-pointer group hover:bg-background-200/70 transition-colors duration-200"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/60 text-background-50 rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                  <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-bold bg-accent-500 text-background-50 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-bold text-foreground-950 line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}